import { StatusScreen } from '@/components/StatusScreen';

/**
 * A menu destination that is declared but has no screen behind it yet.
 *
 * Named for what it is rather than apologising: an empty screen here is a statement about where the
 * product currently ends, not a failure. That is also why it carries no status code — nothing was
 * refused, and printing a number would suggest otherwise.
 *
 * The module is named from the manifest rather than written into the copy, so this stays accurate
 * as Phase 2 fills the menu in. The version this replaced enumerated the six screens that worked;
 * it was already wrong, because Categories shipped and nobody edited the sentence.
 *
 * Rendered inside the shell, deliberately. The sidebar is the thing that got the user here and the
 * only thing that gets them out — a full-page takeover would strand them on the one screen in the
 * product that does nothing.
 */
export function ComingSoonPage({ label, group }: { label: string; group?: string }) {
  return (
    <StatusScreen
      icon="ph-duotone ph-rocket-launch"
      tone="brand"
      title={`${label} is coming soon`}
      message={
        <>
          {group ? `${label} is part of ${group}, and is` : 'This screen is'} planned for a later
          phase. It appears here the moment it ships — there is nothing to switch on.
        </>
      }
    />
  );
}
